import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthenticationService } from '../authentication/services/authentication.service';
import {
    BYPASS_SESSION_REFRESH_INTERCEPTOR,
    SESSION_REFRESH_RETRY_ATTEMPTED,
} from './session-refresh.context';

const SESSION_REFRESH_REQUIRED_STATUS = 428;

/**
 * Refreshes browser authentication state when the BFF refuses to process a request because the
 * session marker is stale, then retries the original request once.
 */
@Injectable()
export class SessionRefreshInterceptor implements HttpInterceptor {
    constructor(private readonly injector: Injector) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: unknown) => {
                if (
                    error instanceof HttpErrorResponse &&
                    error.status === SESSION_REFRESH_REQUIRED_STATUS &&
                    !request.context.get(BYPASS_SESSION_REFRESH_INTERCEPTOR) &&
                    !request.context.get(SESSION_REFRESH_RETRY_ATTEMPTED)
                ) {
                    const retriedRequest = request.clone({
                        context: request.context.set(
                            SESSION_REFRESH_RETRY_ATTEMPTED,
                            true
                        ),
                    });
                    return this.getAuthenticationService()
                        .refreshUserAuth()
                        .pipe(switchMap(() => next.handle(retriedRequest)));
                }
                return throwError(() => error);
            })
        );
    }

    private getAuthenticationService(): AuthenticationService {
        return this.injector.get(AuthenticationService);
    }
}
